import { Card } from "@/components/ui/card";
import { formatNilaiRekap, formatPersen } from "@/lib/survei";

// Tabel Rekap gaya contoh UFP: baris Valid N, Keseluruhan, dimensi versi butir periode; per kolom (SELURUH jenjang / prodi / gabungan)
// nilai (rata-rata individu x 10) + % Puas. Hanya menampilkan `data` dari server (SATU perhitungan dgn Excel); tanpa
// logika peran -- siap dipakai ulang di halaman Admin Prodi.
export default function SurveiRekapTabel({ data, label = "Rekap" }) {
    if (!data) return null;
    if (!data.cukup) {
        return <p className="py-4 text-sm text-slate-500" data-testid="survei-rekap-alasan">{data.alasan}</p>;
    }
    const kolom = data.kolom;
    return (
        <Card className="overflow-hidden">
            <div className="border-b border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700">{label}</div>
            <div className="overflow-x-auto">
                <table className="compact w-full" data-testid="survei-rekap-tabel">
                    <thead className="bg-[#1F4E78] text-white">
                        <tr className="text-xs font-semibold">
                            <th rowSpan={2} className="min-w-[11rem] text-left">Dimensi</th>
                            {kolom.map((k) => <th key={k.judul} colSpan={2} className="text-center">{k.judul}</th>)}
                        </tr>
                        <tr className="text-[11px] font-semibold">
                            {kolom.map((k) => [
                                <th key={`${k.judul}-n`} className="text-right">Nilai</th>,
                                <th key={`${k.judul}-p`} className="pr-3 text-right">% Puas</th>,
                            ])}
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="border-t border-slate-200 bg-slate-50">
                            <td className="font-semibold">Valid N</td>
                            {kolom.map((k) => [
                                <td key={`${k.judul}-n`} className="text-right tabular-nums">{k.valid_n.toLocaleString("id-ID")}</td>,
                                <td key={`${k.judul}-p`} />,
                            ])}
                        </tr>
                        <tr className="border-t border-slate-200 bg-slate-50 font-semibold">
                            <td>Keseluruhan</td>
                            {kolom.map((k) => [
                                <td key={`${k.judul}-n`} className="text-right tabular-nums">{formatNilaiRekap(k.keseluruhan)}</td>,
                                <td key={`${k.judul}-p`} className="pr-3 text-right tabular-nums">{formatPersen(k.persen_keseluruhan)}</td>,
                            ])}
                        </tr>
                        {data.dimensi.map((nama, i) => (
                            <tr key={nama} className="border-t border-slate-200">
                                <td>{nama}</td>
                                {kolom.map((k) => [
                                    <td key={`${k.judul}-n`} className="text-right tabular-nums">{formatNilaiRekap(k.nilai[i])}</td>,
                                    <td key={`${k.judul}-p`} className="pr-3 text-right tabular-nums">{formatPersen(k.persen_puas[i])}</td>,
                                ])}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p className="px-4 py-2 text-xs text-slate-500">
                Nilai = rata-rata skor individu per dimensi × 10 (skala 0–100). % Puas = responden yang rata-rata individunya ≥ 6
                (ukuran laporan KPI). Kelompok kurang dari 5 responden digabung.
            </p>
        </Card>
    );
}
